import './ServicesBlock.css';
import React from "react";
export const ServicesBlock = _ref => {
  let {
    service,
    hostLink,
    rtl
  } = _ref;
  const {
    title,
    tags,
    url,
    introText
  } = service;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "serviceItem"
  }, tags && tags.length ? /*#__PURE__*/React.createElement("div", {
    className: "serviceItem__tags"
  }, tags.map((tag, index) => {
    return index ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, ' · '), /*#__PURE__*/React.createElement("span", null, tag)) : /*#__PURE__*/React.createElement("span", null, tag);
  })) : null, /*#__PURE__*/React.createElement("h4", {
    className: "serviceItem__title body-medium"
  }, /*#__PURE__*/React.createElement("a", {
    href: url,
    title: title,
    "aria-label": "Title",
    "aria-labelledby": "Title"
  }, title)), /*#__PURE__*/React.createElement("p", {
    className: "serviceItem__description body-small"
  }, introText)));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles}`
  }, children);
};
export const commonStyles = "c1u54o3c";